<template>
  <div>
    <v-tabs v-model="currentTab" slider-color="primary">
      <v-tab v-for="tab in tabs" :key="tab.value" :href="`#${tab.value}`">{{ tab.text }}</v-tab>
    </v-tabs>
    <PreviewConversation
      class="mt-3"
      :show-multiple-channel="showMultipleChannel"
      :intent="intent"
      :answers="answers"
      :tab="socialTab"
      :multi-messages="multiMessages"
      :is-comment-to-inbox="isCommentToInbox"
      :hide-choice="hideChoice"
      :replies="replies"
      @handleChangeTab="socialTab = $event"
    />
  </div>
</template>

<script>
import PreviewConversation from '@/components/elements/Conversation/PreviewConversation'

export default {
  components: { PreviewConversation },
  props: {
    showMultipleChannel: {
      type: Boolean,
      default: false
    },
    intent: {
      type: Object,
      default: null
    },
    isCommentToInbox: {
      type: Boolean,
      default: false
    },
    hideChoice: {
      type: Boolean,
      default: false
    },
    replies: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      currentTab: 'correct',
      tabs: [
        { value: 'correct', text: this.$t('slip_verification_correct') },
        { value: 'incorrect', text: this.$t('slip_verification_incorrect') },
        { value: 'error', text: this.$t('slip_verification_error') },
        { value: 'duplicate', text: this.$t('slip_verification_duplicate') }
      ],
      socialTab: 'fb'
    }
  },
  computed: {
    answers() {
      return [
        this.intent.verify_slip_setting
          ? this.intent.verify_slip_setting[`${this.currentTab}_a_val`] || []
          : []
      ]
    },
    multiMessages() {
      return this.conversationSocialChannelOptions.reduce(
        (acc, option) => ({
          ...acc,
          [`${option.value}_answers`]: [
            this.intent.verify_slip_setting
              ? this.intent.verify_slip_setting[`${this.currentTab}_${option.value}_val`] || []
              : []
          ]
        }),
        {}
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/intent/IntentSlipVerificationPreview.vue